import { SagaIterator } from "redux-saga";
import { all, call, put, takeLatest } from "redux-saga/effects";
import actions from "./actions";
import { API } from "common";
import mappingBlockHour from "views/calendar/CalendarUI/mappingBlockHour";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { NotificationListQuery, NotificationUnreadQuery } from "types/models";

const getNotifications = function* ({ payload }: PayloadAction<NotificationListQuery>): SagaIterator {
  // URLSearchParams' typings want Record<string, string>; payload carries numeric/optional
  // fields (page, size) that stringify fine at runtime — cast preserves existing behavior.
  const query = new URLSearchParams(payload as any) ?? '';

  try {
    const response = yield call(API.get, `/staff-notification/list?${query.toString()}`);
    if (response.status == 200) {
      const { payload } = response.data;
      yield put(actions.getNotifications.success(payload));
    }
  } catch (error) {
    console.log('getNotifications error', error);

    yield put(actions.getNotifications.fail([]));
  }
}

const countNotificationUnread = function* ({ payload }: PayloadAction<NotificationUnreadQuery>): SagaIterator {
  const queryString = new URLSearchParams(payload as any)?.toString() ?? '';

  try {
    const response = yield call(API.get, `/staff-notification/unread-count?${queryString}`);
    if (response.status == 200) {
      const { payload } = response.data;
      yield put(actions.countNotificationUnread.success(payload));
    }
  } catch (error) {
    console.log('countNotificationUnread error', error);
    yield put(actions.countNotificationUnread.fail([]));
  }
}

export default function* notificationServiceSagas(): SagaIterator {
  yield takeLatest(actions.getNotifications.fetch, getNotifications);
  yield takeLatest(actions.countNotificationUnread.fetch, countNotificationUnread);
}
